module.exports = __webpack_public_path__ + "img/get app.8e4ae722.png";